import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Zap } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import DiagnosticSeal from "@/components/DiagnosticSeal";
import "@/components/DiagnosticsExperience.css";
import api, { formatApiError } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";

const energy=(value)=>`${new Intl.NumberFormat("es-CO",{maximumFractionDigits:2}).format(value||0)} Energía KD9`;

const Diagnosticos=()=>{
  const {t}=useLanguage();
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState("");

  const loadCatalog=useCallback(async()=>{
    setLoading(true); setError("");
    try{
      const {data}=await api.get("/api/diagnostics/public/catalog");
      setItems(Array.isArray(data)?data:[]);
    }catch(err){
      setItems([]);
      setError(formatApiError(err));
    }finally{
      setLoading(false);
    }
  },[]);

  useEffect(()=>{loadCatalog();},[loadCatalog]);
  return <div className="kd9-diagnostics kd9-diagnostics-public min-h-screen" data-testid="diagnosticos-page">
    <PublicNav/>
    <section className="diagnostic-hero max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
      <div className="diagnostic-hero-copy">
      <div className="diagnostic-eyebrow font-mont text-[11px] tracking-[0.45em] uppercase mb-5">· {t("nav.diagnosticos")} ·</div>
      <h1 className="diagnostic-hero-title font-cinzel mb-4">{t("section.diagnosticos").toUpperCase()}</h1>
      <p className="diagnostic-hero-description font-cormorant text-xl max-w-2xl">{t("section.process")}</p>
      <div className="diagnostic-hero-signature" aria-hidden="true"><span />KHAOS DELTA 9<span /></div>
      </div>
      <DiagnosticSeal />
    </section>
    <section className="diagnostic-catalog max-w-7xl mx-auto px-6 lg:px-10 pb-20">
      {loading&&<div className="diagnostic-state kd9-card p-8 font-mont text-sm">Cargando diagnósticos…</div>}
      {!loading&&error&&<div className="diagnostic-state kd9-card p-8">
        <div className="font-mont text-sm" style={{color:"var(--diag-error)"}}>No pudimos cargar los diagnósticos: {error}</div>
        <button type="button" onClick={loadCatalog} className="kd9-btn-primary mt-4 px-5 py-3 rounded-lg text-[11px]">Reintentar</button>
      </div>}
      {!loading&&!error&&items.length===0&&<div className="diagnostic-state kd9-card p-8 font-cormorant text-xl" style={{color:"var(--kd9-text-soft)"}}>Próximamente publicaremos nuevos diagnósticos KD9.</div>}
      <div className="diagnostic-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((item,i)=><article key={item.slug} className={`diagnostic-card kd9-card overflow-hidden kd9-fade-up kd9-delay-${(i%6)+1}`} style={{"--study-tone":item.tone||"#D4AF37"}} data-testid={`diag-card-${item.slug}`}>
        <div className="diagnostic-card-media relative h-56">
          {(item.coverImageUrl||item.cover_url)?<img src={item.coverImageUrl||item.cover_url} alt={item.title} loading="lazy" decoding="async" className="w-full h-full object-cover"/>:<div className="w-full h-full flex items-center justify-center" style={{background:`radial-gradient(circle,${item.tone||"#D4AF37"}33,transparent 70%)`}}><Sparkles size={58} style={{color:item.tone||"#D4AF37"}}/></div>}
          <div className="diagnostic-image-shade absolute inset-0"/>
          <span className="diagnostic-duration absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] font-mont uppercase font-semibold" >{item.duration||item.category}</span>
          {item.featured&&<span className="diagnostic-featured absolute top-4 right-4 px-3 py-1 rounded-full text-[10px] font-mont uppercase">Destacado</span>}
          <div className="diagnostic-card-emblem absolute bottom-3 left-4 font-cinzel text-5xl">{item.icon||"✦"}</div>
        </div>
        <div className="diagnostic-card-body p-6">
          <h3 className="diagnostic-card-title font-cinzel text-xl mb-2">{item.title.toUpperCase()}</h3>
          <p className="diagnostic-description font-cormorant text-base mb-4 min-h-[60px]">{item.description}</p>
          {item.requirements?.length>0&&<div className="diagnostic-card-section mb-4"><div className="font-mont text-[10px] uppercase tracking-widest mb-1">Requisitos</div><ul className="diagnostic-detail-list font-mont text-[11px] list-disc pl-4">{item.requirements.map(x=><li key={x}>{x}</li>)}</ul></div>}
          {item.deliverables?.length>0&&<div className="diagnostic-card-section mb-4"><div className="font-mont text-[10px] uppercase tracking-widest mb-1">Incluye</div><ul className="diagnostic-detail-list font-mont text-[11px] list-disc pl-4">{item.deliverables.map(x=><li key={x}>{x}</li>)}</ul></div>}
          <div className="diagnostic-card-footer flex items-end justify-between gap-3"><div><div className="text-[10px] font-mont uppercase">Costo en energía</div><div className="diagnostic-price font-cinzel text-xl">{energy(item.energy_cost)}</div></div>
          <Link to="/register" className="diagnostic-primary kd9-btn-primary px-5 py-3 rounded-lg text-[11px] flex items-center gap-2">{item.category==="rapida"&&<Zap size={12}/>} {t("diag.cta")} <ArrowRight size={14}/></Link></div>
        </div>
      </article>)}</div>
    </section>
    <Footer/>
  </div>;
};
export default Diagnosticos;
